export default __webpack_public_path__ + "locales/en/DeleteProfileEverDialog.json?hash=89f6c7ff88578d5a53fe07c6c4aeaa55";